import React from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const ProBedHistory = ({formModel})=>{    
    return <div>
         <DataTable value={formModel}>
            <Column field="dateTime" header="Date&Time"></Column>
            <Column field="program" header="Program"></Column>
            <Column field="occupantType" header="Occupant Type"></Column>
            <Column field="occupantName" header="Occupant Name"></Column>
            <Column field="primaryStaff" header="Primary Staff"></Column>
            <Column field="assigningStaff" header="Assigning Name"></Column>
        </DataTable>

    </div>
}

export default ProBedHistory;